export default __webpack_public_path__ + "static/media/collapse.e8f527b4.svg";